<template>
  <lb-dialog
    v-model="showDialog" :heading="dialogMode === 'edit' ? 'Edit Feature' : 'Feature Details'"
    width="600" :loading="loading">
    <template v-slot:body>
      <v-row class="align-center">
        <template v-for="field in fields">
          <template v-if="field.type === 'threshold'">
            <v-col :key="field.key + '-label'" cols="3">{{ field.label }}:</v-col>
            <v-col :key="field.key + '-value'" cols="9" class="d-flex flex-wrap align-center">
              <template v-if="dialogData.threshold && typeof dialogData.threshold === 'object'">
                <v-chip class="ma-1" color="cyan lighten-4" text-color="primary">
                  <span>Total: {{ dialogData.threshold.total }}</span>
                </v-chip>
                <v-chip class="ma-1" color="lime lighten-4" text-color="primary">
                  <span>Per Minute: {{ dialogData.threshold.minute }}</span>
                </v-chip>
              </template>
              <template v-else>
                <v-chip class="ma-1" color="grey lighten-2" text-color="primary">
                  <span>{{ dialogData.threshold }}</span>
                </v-chip>
              </template>
            </v-col>
          </template>
          <template v-else-if="field.type === 'status'">
            <v-col :key="field.key + '-status'" cols="12" class="d-flex align-center">
              <span class="mr-3">{{ field.label }}</span>
              <v-switch
                v-if="dialogMode === 'edit'"
                :value="dialogData.status"
                :label="dialogData.status ? 'Active' : 'Inactive'"
                inset color="success" :false-value="false" :true-value="true"
                @change="val => $emit('update:dialogData', { ...dialogData, status: val })"
              />
              <v-icon v-else :color="dialogData.status === true ? 'success' : 'error'">
                {{ dialogData.status === true ? 'mdi-check-circle' : 'mdi-close-circle' }}
              </v-icon>
            </v-col>
          </template>
          <template v-else-if="field.type === 'promptVariants'">
            <v-col :key="field.key + '-prompt'" cols="12">
              <div v-if="Array.isArray(dialogData.prompt_variants_data) && dialogData.prompt_variants_data.length">
                <div class="font-size-md font-weight-medium mb-2">{{ field.label }}:</div>
                <v-expansion-panels>
                  <v-expansion-panel
                    v-for="(variant, i) in dialogData.prompt_variants_data" :key="i">
                    <v-expansion-panel-header>
                    <span>
                      {{ variant.template_name }}
                    </span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="3">Template Name:</v-col>
                      <v-col cols="9">{{ variant.template_name }}</v-col>
                    </v-row>
                    <v-row v-if="variant.version !== undefined">
                      <v-col cols="3">Version:</v-col>
                      <v-col cols="9">{{ variant.version }}</v-col>
                    </v-row>
                    <v-row v-if="variant.type">
                      <v-col cols="3">Type:</v-col>
                      <v-col cols="9">{{ variant.type }}</v-col>
                    </v-row>
                    <v-row v-if="variant.created_by">
                      <v-col cols="3">Created By:</v-col>
                      <v-col cols="9">{{ variant.created_by }}</v-col>
                    </v-row>
                    <v-row v-if="variant.content">
                      <v-col cols="12">Prompt:</v-col>
                      <v-col cols="12">
                      <v-sheet class="pa-2" color="grey lighten-4" rounded>
                        <pre class="ma-0" style="white-space: pre-wrap; word-break: break-word;">
                          {{ variant.content && variant.content.length > 300 
                            ? variant.content.slice(0, 300) + '...' 
                            : variant.content 
                          }}
                        </pre>
                      </v-sheet>
                      </v-col>
                    </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
            </v-col>
          </template>
          <template v-else-if="field.key === 'model'">
            <v-col :key="field.key + '-label'" cols="3">{{ field.label }}:</v-col>
            <v-col :key="field.key + '-value'" cols="9">
              <span class="caccounting--text v-chip v-chip--label theme--light v-size--default lightpurple">
                {{ dialogData.model }}
              </span>
            </v-col>
          </template>
          <template v-else-if="field.key === 'templateName'">
            <v-col :key="field.key + '-label'" cols="3">{{ field.label }}:</v-col>
            <v-col :key="field.key + '-value'" cols="9">
              <template v-if="Array.isArray(dialogData.prompt_variants_data) && dialogData.prompt_variants_data.length">
                <v-chip-group column>
                  <v-chip v-for="(variant, i) in dialogData.prompt_variants_data"
                    :key="i" class="ma-1" color="amber lighten-4">
                    <span>{{ variant.template_name }}</span>
                  </v-chip>
                </v-chip-group>
              </template>
              <template v-else>
                <span>{{ dialogData.templateName }}</span>
              </template>
            </v-col>
          </template>
          <template v-else>
            <v-col :key="field.key + '-label'" cols="3">{{ field.label }}:</v-col>
            <v-col :key="field.key + '-value'" cols="9">{{ dialogData[field.key] }}</v-col>
          </template>
        </template>
      </v-row>
    </template>
    <template v-slot:actions>
      <v-spacer></v-spacer>
      <v-btn v-if="dialogMode === 'edit'" color="primary" @click="$emit('save')"><span>Save</span></v-btn>
      <v-btn @click="$emit('close')">
        <span>{{ dialogMode === 'edit' ? 'Cancel' : 'Close' }}</span>
      </v-btn>
    </template>
  </lb-dialog>
</template>

<script>
export default {
  name: 'FeatureDialog',
  props: {
    showDialog: Boolean,
    dialogMode: String,
    dialogData: Object,
    fields: {
      type: Array,
      required: true,
      default: () => []
    },
    loading: Boolean
  }
};
</script>